module.exports = __webpack_public_path__ + "static/media/icon_quality.e75ff4db.svg";